import { useKeycloak } from "@react-keycloak/web";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import AppLoader from "@lxp-app/components/atoms/app-loader/appLoader";
import AuthoringSkeleton from "@lxp-app/components/atoms/app-loader/authoringSkeleton";
import { useSelector } from "react-redux";
import { RootState } from "@lxp-app/store/store";
import { IS } from "@lxp-app/store/slices/userInfoSlice";
import { checkRole } from "@lxp-app/routes/guards/checkRole";

const ProtectedRoutes = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const user: IS = useSelector((state: RootState) => state.UserInfoSlice);
  const { keycloak } = useKeycloak();

  if (keycloak.authenticated !== undefined && !keycloak.authenticated) {
    keycloak.login({
      redirectUri: `${window.location}`
    });
  }
  const isAuthoringRoute = location.pathname.startsWith("/authoring");

  if (
    !keycloak.authenticated ||
    !user.profile.id ||
    !user.profile.name.firstName
  ) {
    if (user.profile.unAuthorized) {
      return <Outlet />;
    }

    return isAuthoringRoute ? (
      <AuthoringSkeleton />
    ) : (
      <AppLoader loadingText="Loading" />
    );
  }

  if (
    keycloak.authenticated !== undefined &&
    keycloak.authenticated &&
    user.profile.id
  ) {
    const isAccessDenied = checkRole(location.pathname, user?.profile?.role);

    if (isAccessDenied) {
      navigate("/error/forbidden", { replace: true });
      return;
    }
    return <Outlet />;
  }
};

export default ProtectedRoutes;
